<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useMapGetter } from 'dashboard/composables/store';

const props = defineProps({
  userId: {
    type: [Number, String],
    default: null,
  },
});

const { t } = useI18n();
const agents = useMapGetter('agents/getAgents');

const isOnline = computed(() => {
  const agent = (agents.value || []).find(a => a.id === props.userId);
  return agent?.availability_status === 'online';
});

const ariaLabel = computed(() =>
  isOnline.value
    ? t('INTERNAL_CHAT.PRESENCE.ONLINE')
    : t('INTERNAL_CHAT.PRESENCE.OFFLINE')
);
</script>

<template>
  <span
    class="inline-block rounded-full size-2 shrink-0"
    :class="isOnline ? 'bg-n-teal-9' : 'bg-n-slate-7'"
    :aria-label="ariaLabel"
    :title="ariaLabel"
  />
</template>
